import "core-js/modules/es.array.unscopables.flat-map.js";
var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from "react";
import styled from "styled-components";
import { CircularProgress, Typography } from "@material-ui/core";
import { useTypedSelector } from "../../state/store";
import { useDispatch } from "react-redux";
import { requestReviews } from "../../state/receivedReviews/actions";
import ReceivedPeerReview from "./ReceivedPeerReview";
import { BoldTypography, TopMarginDivLarge, withMargin } from "../styleComponents";
import ThemeProviderContext from "../../contexes/themeProviderContext";
import Togglable from "../../utils/Togglable";
var ReceivedPeerReviewsContainer = styled(TopMarginDivLarge)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var Loading = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 1.5rem 0 0 1rem;\n  p {\n    margin-top: 0.5rem;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 1.5rem 0 0 1rem;\n  p {\n    margin-top: 0.5rem;\n  }\n"])));
var Received = styled(TopMarginDivLarge)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var ReceivedPeerReviews = function () {
  var dispatch = useDispatch();
  var themeProvider = React.useContext(ThemeProviderContext);
  var receivedReviews = useTypedSelector(function (state) {
    return state.receivedReviews.reviews;
  });
  var error = useTypedSelector(function (state) {
    return state.message.error;
  });
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var languageLabels = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  if (!quiz) {
    return React.createElement("div", null, "Quiz somehow not set. Try reloading the page");
  }
  if (!languageLabels) {
    return React.createElement("div", null, "Language not set (should set to English then)");
  }
  var receivedReviewsLabels = languageLabels.receivedPeerReviews;
  React.useEffect(function () {
    dispatch(requestReviews());
  }, []);
  var peerReviewQuestions = quiz.peerReviewCollections[0].questions;
  if (!receivedReviews) {
    return React.createElement(Loading, null, error ? React.createElement("div", null) : React.createElement(React.Fragment, null, React.createElement(CircularProgress, {
      size: 25
    }), React.createElement(Typography, null, receivedReviewsLabels.loadingLabel)));
  }
  return React.createElement(Received, {
    providedStyles: themeProvider.receivedPeerReviewsStyles
  }, React.createElement(ReceivedReviewsSummary, {
    peerReviews: receivedReviews,
    peerReviewQuestions: peerReviewQuestions,
    receivedReviewsLabels: receivedReviewsLabels
  }), receivedReviews.length > 0 && React.createElement(Togglable, {
    initiallyVisible: false,
    hideButtonText: receivedReviewsLabels.toggleButtonShrinkLabel,
    displayButtonText: receivedReviewsLabels.toggleButtonExpandLabel,
    scrollRef: null
  }, React.createElement(ReceivedReviewsDetailed, {
    peerReviews: receivedReviews,
    peerReviewQuestions: peerReviewQuestions,
    receivedReviewsLabels: receivedReviewsLabels
  })));
};
var ReceivedReviewsDetailed = function (_a) {
  var peerReviews = _a.peerReviews,
    peerReviewQuestions = _a.peerReviewQuestions,
    receivedReviewsLabels = _a.receivedReviewsLabels;
  return React.createElement("div", {
    style: {
      marginTop: 20
    }
  }, peerReviews.sort(function (rev1, rev2) {
    return rev2.createdAt.getTime() - rev1.createdAt.getTime();
  }).map(function (pr, idx) {
    return React.createElement(ReceivedPeerReview, {
      key: pr.id,
      questions: peerReviewQuestions,
      answer: pr,
      idx: idx,
      receivedReviewsLabels: receivedReviewsLabels
    });
  }));
};
var ReceivedReviewsSummary = function (_a) {
  var peerReviews = _a.peerReviews,
    receivedReviewsLabels = _a.receivedReviewsLabels;
  var gradeAnswers = peerReviews.flatMap(function (review) {
    return review.answers.filter(function (a) {
      return typeof a.value === "number";
    }).map(function (prqa) {
      return prqa.value;
    });
  });
  var average = "-";
  if (gradeAnswers.length > 0) {
    average = gradeAnswers.reduce(function (sum, e) {
      return sum += e;
    }) / gradeAnswers.length;
    average = average.toFixed(2);
  }
  var Title = withMargin(BoldTypography, "1rem 0 0");
  var Body = withMargin(Typography, "0.5rem 0 0");
  return React.createElement("div", null, React.createElement(Title, null, receivedReviewsLabels.summaryViewLabel), peerReviews.length === 0 ? React.createElement(Body, {
    component: "p",
    variant: "subtitle1"
  }, receivedReviewsLabels.noPeerReviewsReceivedlabel) : React.createElement(Body, null, receivedReviewsLabels.numberOfPeerReviewsText(peerReviews.length), " ", receivedReviewsLabels.averageOfGradesLabel, " ", average + "."));
};
export default ReceivedPeerReviews;
var templateObject_1, templateObject_2, templateObject_3;